import { useEffect, useState } from 'react';
import { isMobile as isMobileUA } from 'react-device-detect';

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkIfMobile = () => {
            const hasTouch =
                'ontouchstart' in window ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0;

            const isSmallScreen = window.innerWidth < 1024;
            const isLikelyMobile = isMobileUA || (hasTouch && isSmallScreen);

            setIsMobile(isLikelyMobile);
        };

        checkIfMobile();

        // Update on resize or orientation change
        window.addEventListener('resize', checkIfMobile);
        window.addEventListener('orientationchange', checkIfMobile);

        return () => {
            window.removeEventListener('resize', checkIfMobile);
            window.removeEventListener('orientationchange', checkIfMobile);
        };
    }, []);

    return isMobile;
}
